import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const consumerPropertiesKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...keys, id] as const,
      }),
  });

export { consumerPropertiesKeys };
